import { render, staticRenderFns } from "./CorrelationWidget.vue?vue&type=template&id=2a42e20b&scoped=true&"
import script from "./CorrelationWidget.vue?vue&type=script&lang=js&"
export * from "./CorrelationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42e20b",
  null
  
)

export default component.exports